
import { EventBus } from '@marketplace/plugins/event-bus.js'

export default {
    name: 'ModalContent',

    props: {
        title: {
            type: String,
            required: true,
        },
        content: {
            type: String,
            required: true,
        },
        submitLabel: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            isSubmitting: false,
        }
    },

    mounted() {
        EventBus.$emit('modal-prompt:mounted')
    },

    destroyed() {
        EventBus.$emit('modal-prompt:destroyed')
    },

    methods: {
        submit() {
            this.isSubmitting = true
            EventBus.$emit('modal-prompt:submit')
        },

        close() {
            EventBus.$emit('modal-close')
        },
    },
}
